export default __webpack_public_path__ + "media/images/68-682093b1ce56839bc6fc337f844989da.jpg";